const shadow = {
  'level-1': '0px  2px  6px      rgba(0, 0, 0, 0.24)',
  'level-2': '0px  3px 10px -1px rgba(0, 0, 0, 0.28)',
  'level-3': '0px  4px 14px -1px rgba(0, 0, 0, 0.36)',
  'level-4': '0px  6px 12px -1px rgba(0, 0, 0, 0.48)',
  'level-5': '0px 14px 40px -2px rgba(0, 0, 0, 0.64)',
}

module.exports = shadow
